import type { FaireProductEntity } from "../../entity_types/product";

export const p_443grnhyds: FaireProductEntity = {
  token: "p_443grnhyds",
  type: "product",
  name: "Orange Grove Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ad0cd72dc88131af21bd07a9f7d9248e09b77becd351f89346e69d003797feab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99a227270e240e16a25bde0b43062bba9444821603b0452dcfb31e12e6e9fe03.jpeg",
    "https://cdn.faire.com/fastly/f0e9511b7529a7f72517523a41191bb0c2dc669825a576149a877af002c29faf.jpeg",
    "https://cdn.faire.com/fastly/5b3e213d43b676a973dc360a7c539c203c34c070e604b96de4ac91690e1e08fc.png",
    "https://cdn.faire.com/fastly/22b4bdb2743081d4553a6c15ed4380fd1e56e9511c4c5ee0b7d1f29b6ad42c02.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:41.386Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
